/**
 * Validation utilities for form fields
 */

/**
 * Validate email format
 * @param {string} value - Email to validate
 * @returns {string|null} Error message or null if valid
 */
export const validateEmail = value => {
  if (!value) return 'דוא"ל הוא שדה חובה';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'כתובת דוא"ל לא תקינה';
  return null;
};

/**
 * Validate Israeli phone number format (05X-XXX-XXXX)
 * @param {string} value - Phone number to validate
 * @returns {string|null} Error message or null if valid
 */
export const validatePhone = value => {
  if (!value) return 'טלפון הוא שדה חובה';

  // Remove formatting to check digits
  const digits = value.replace(/\D/g, '');

  // Israeli mobile: 10 digits starting with 05
  if (digits.length < 10) return 'מספר טלפון חייב להכיל 10 ספרות';
  if (!digits.startsWith('05')) return 'מספר טלפון חייב להתחיל ב-05';

  return null;
};

/**
 * Validate required field
 * @param {string} value - Value to check
 * @param {string} fieldName - Field name for error message
 * @returns {string|null} Error message or null if valid
 */
export const validateRequired = (value, fieldName = 'שדה זה') => {
  if (!value || !value.trim()) return `${fieldName} הוא שדה חובה`;
  return null;
};

/**
 * Validate password
 * @param {string} value - Password to validate
 * @returns {string|null} Error message or null if valid
 */
export const validatePassword = value => {
  if (!value) return 'סיסמה היא שדה חובה';
  if (value.length < 8) return 'הסיסמה חייבת להכיל לפחות 8 תווים';
  return null;
};

/**
 * Check if email format is valid (boolean version)
 * @param {string} value - Email to check
 * @returns {boolean} True if valid
 */
export const isValidEmail = value => {
  if (!value) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

/**
 * Check if phone format is valid (boolean version)
 * @param {string} value - Phone to check
 * @returns {boolean} True if valid
 */
export const isValidPhone = value => {
  if (!value) return false;
  const digits = value.replace(/\D/g, '');
  return digits.length === 10 && digits.startsWith('05');
};
